{
	"ariaCancelPhotoExport": "Cancel Photo Export",
	"ariaSelectBitDepth": "Select Bit Depth",
	"ariaSelectColorSpace": "Select Color Space",
	"ariaSelectDimensionSide": "Select Dimension Side",
	"ariaSelectDimensionType": "Select Dimension Type",
	"ariaSelectFilenamePattern": "Select Filename Pattern",
	"ariaSelectImageFormat": "Select Image Format",
	"bit": "{{bitDepth}} bit",
	"bit2": "{{option}} bit",
	"bitDepth": "Bit Depth",
	"cancelExportMessage": "The remaining photos awaiting to be exported will be canceled.",
	"cancelExportPrimary": "Cancel Export",
	"cancelExportTitle": "Are you sure?",
	"cancellingExport": "Cancelling export and restoring the current photo...",
	"colorSpace": "Color Space",
	"colorSpaceDisplayP3": "Display P3",
	"confirmExportPhoto": "Confirm Export {{photoCount}} Photo{{var1}}",
	"customDimensionError": "One or more photos are too small to export with the current custom dimensions. Increase the dimensions to continue.",
	"customDimensionError2": "One or more photos exceed the 12,000 × 12,000 px custom export limit. Reduce the custom dimensions to continue.",
	"customName": "Custom Name",
	"dimensionCustom": "Custom",
	"dimensionFullSize": "Full size",
	"dimensionLongSide": "Long side",
	"dimensionShortSide": "Short side",
	"dimensions": "Dimensions",
	"doNotLeaveApp": "Do not leave the app, doing so could corrupt the exported photos.",
	"doYouWantToOverwrite": "Do you want to overwrite the existing {{fileOrFiles}} or skip the existing {{fileOrFiles}} or cancel\n\tthe export?",
	"estimatedExportSize": "Estimated Export Size",
	"example": "Example",
	"existingFound": "{{fileCount}} existing {{fileOrFiles}} found",
	"exportImageCount_one": "Export {{count}} Image",
	"exportImageCount_other": "Export {{count}} Images",
	"exportingProgress": "Exporting photos... {{saves}}/{{totalToSave}}",
	"failedToExportPleaseTry": "Failed to export. Please try again later.",
	"fileName": "File Name",
	"filenameCustomOriginalNumber": "Custom Name - Original File Number",
	"filenameCustomSequence": "Custom Name - Sequence",
	"filenameDateFilename": "Date - Filename",
	"filenameOriginal": "Original",
	"imageType": "Image Type",
	"imageTypeJpeg": "JPEG",
	"imageTypePsd": "PSD",
	"imageTypeTiff": "TIFF",
	"noWatermark": "No Watermark",
	"overwrite": "Overwrite",
	"ppiUnit": "PPI",
	"pxUnit": "px",
	"quality": "Quality",
	"resolution": "Resolution",
	"setupInClientGallery": "Setup in Client Gallery",
	"startNumber": "Start Number",
	"title": "Export",
	"watermark": "Watermark"
}
